export type Role = 'superAdmin' | 'admin' | 'marketingLead'

export type Permission =
  | 'campaigns.view'
  | 'campaigns.create'
  | 'campaigns.edit'
  | 'campaigns.delete'
  | 'projects.view'
  | 'projects.edit'
  | 'projects.approve'
  | 'projects.upload'
  | 'clips.view'
  | 'clips.submit'
  | 'editedContent.view'
  | 'users.view'
  | 'users.export'
  | 'groups.view'
  | 'groups.create'
  | 'groups.edit'
  | 'groups.delete'
  | 'rewards.view'
  | 'rewards.create'
  | 'rewards.edit'
  | 'rewards.delete'
  | 'analytics.view'
  | 'regionalReports.view'
  | 'branding.view'
  | 'branding.edit'
  | 'settings.view'
  | 'settings.editAdmins'
  | 'pushNotifications.view'
  | 'pushNotifications.send'
  | 'billing.view'
  | 'billing.manage'

const rolePermissions: Record<Role, Permission[]> = {
  superAdmin: [
    'campaigns.view',
    'campaigns.create',
    'campaigns.edit',
    'campaigns.delete',
    'projects.view',
    'projects.edit',
    'projects.approve',
    'projects.upload',
    'clips.view',
    'clips.submit',
    'editedContent.view',
    'users.view',
    'users.export',
    'groups.view',
    'groups.create',
    'groups.edit',
    'groups.delete',
    'rewards.view',
    'rewards.create',
    'rewards.edit',
    'rewards.delete',
    'analytics.view',
    'regionalReports.view',
    'branding.view',
    'branding.edit',
    'settings.view',
    'settings.editAdmins',
    'pushNotifications.view',
    'pushNotifications.send',
    'billing.view',
    'billing.manage',
  ],
  admin: [
    'campaigns.view',
    'campaigns.create',
    'campaigns.edit',
    'campaigns.delete',
    'projects.view',
    'projects.edit',
    'projects.approve',
    'projects.upload',
    'clips.view',
    'clips.submit',
    'editedContent.view',
    'users.view',
    'users.export',
    'groups.view',
    'groups.create',
    'groups.edit',
    'groups.delete',
    'rewards.view',
    'rewards.create',
    'rewards.edit',
    'rewards.delete',
    'analytics.view',
    'regionalReports.view',
    'branding.view',
    'branding.edit',
    'settings.view',
    'settings.editAdmins',
    'pushNotifications.view',
    'pushNotifications.send',
    'billing.view',
    'billing.manage',
  ],
  marketingLead: [
    'campaigns.view',
    'projects.view',
    'clips.view',
    'editedContent.view',
    'users.view',
    'groups.view',
    'analytics.view',
  ],
}

export function hasPermission(role: Role, permission: Permission): boolean {
  return rolePermissions[role]?.includes(permission) ?? false
}

export function getRole(isGlobalAdmin: boolean, teamRole?: string): Role {
  if (isGlobalAdmin) return 'superAdmin'
  if (teamRole === 'marketingLead') return 'marketingLead'
  return 'admin'
}
